<template lang="pug">
  .container-walletVerify.container-padding
    c-header-small.wallet-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/payment") 收款账户管理
          el-breadcrumb-item(:to="'/payment/' + account_id" ) 收款账户详情
          el-breadcrumb-item 钱包验证
    cBox.iframeBox
      iframe(:src="redirect_url", frameborder="0", ref="iframe", v-if="redirect_url").iframe
</template>

<script>
export default {
  data () {
    return {
      data:   {},
    };
  },
  computed: {
    account_id () {
      return this.$route.params.account_id;
    },
    redirect_url () {
      return this.data.redirect_url || null;
    },
  },
  methods: {
    getVerify () {
      const account_id = this.account_id;

      return this.$store.dispatch('VERIFY_WALLET', account_id).then((data) => {
        this.data = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取钱包验证信息失败。${code}：${msg}`,
        });
      });
    }
  },
  mounted () {
    if (!this.account_id) {
      this.$router.replace('/paymentList');
    } else {
      this.getVerify();
    }
  },
};
</script>

<style lang="less">
.container-walletVerify {
  display:        flex;
  flex-direction: column;
  height:         100%;

  .wallet-header {
    padding-top:  20px;
  }
}
</style>
